// "Allowing in 2 s · Cancel" (SPEC 5.4, reworded after the 24 Oct live test). The banner leads with what the tap
// will do, in that effect's symbol and tint, so a mis-tap is obvious while it can still be cancelled. Cancel is a real
// button, labelled, reachable by TalkBack, and nothing has left the phone until the count reaches zero.
import { useApp, useHold } from "../app/AppContext";
import { holdSeconds } from "../lib/hold";
import { EffectMark, HOLD_VERB } from "./EffectMark";

export function HoldBanner() {
  const hold = useHold();
  const { controller } = useApp();
  if (!hold) return null;
  const secs = holdSeconds(hold.remainingMs);
  const progress = 1 - hold.remainingMs / hold.totalMs;
  return (
    <div className={`hold hold-${hold.effect}`} role="status" aria-live="assertive" aria-atomic="true">
      <EffectMark effect={hold.effect} />
      <div className="txt">
        <b className="num">{`${HOLD_VERB[hold.effect]} in ${secs} s`}</b>
        <span>
          {hold.summary} to {hold.agentName}. Nothing has left your phone yet.
        </span>
      </div>
      <button type="button" className="btn" onClick={() => controller.cancelHold("user")} aria-label={`Cancel sending ${hold.summary} to ${hold.agentName}`}>
        Cancel
      </button>
      <div className="track" aria-hidden="true">
        <i style={{ transform: `scaleX(${progress})` }} />
      </div>
    </div>
  );
}
